/**
 * Banyan application version — the single source of truth for the human-facing
 * "Banyan X.Y.Z" shown on the Info page. Distinct from the per-deploy git build
 * SHA (which stays for log correlation / debugging).
 *
 * Semantic versioning, per the product owner's convention:
 *   - PATCH (last digit)  -> bump on every bug fix.
 *   - MINOR (middle digit) -> bump on feature / major-behaviour changes.
 *   - MAJOR (first digit)  -> bump ONLY when the developers explicitly demand it.
 *
 * Keep backend/app/main.py `/version` ("version": "X.Y.Z") in sync when this
 * changes.
 */
export const APP_VERSION = '1.0.0';

/** Display string, e.g. "Banyan 1.0.0". */
export const APP_VERSION_LABEL = `Banyan ${APP_VERSION}`;
